import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { TomatoButton } from '../../Layout/CommonStyle'
import { axiosPost } from '../../Common/Axios'
import { ApiResult } from '../../../models/Enums'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import ResultJobsItem from './ResultJobsItem'
import { ResultJobsDto } from '../../../models/Dto/ResultJobsDto'
import toast from 'react-hot-toast'
import ResultJobsPopup from './ResultJobsPopup'

function Evaluator() {
  const [resultJobsDtos, setResultJobsDtos] = useState<ResultJobsDto[]>([])
  const [resultJobsDto, setResultJobsDto] = useState<ResultJobsDto | undefined>(
    undefined
  )
  const [isPopup, setIsPopup] = useState(false)

  const me = useAppSelector((state: RootState) => state.user.me)
  const dispatch = useAppDispatch()

  const loadResultJobsList = async () => {
    const result = await axiosPost('/api/jobs/get_result_jobs_evaluation', {
      userGroupId: me.groupId,
      userId: me.id,
    })

    console.log('loadResultJobsList', result)
    if (result.apiResult !== ApiResult.SUCCESS) {
      console.log('get_result_jobs_list error', result.message)
      return
    }

    console.log('loadResultJobsList', result.data)

    setResultJobsDtos(result.data)
  }

  useEffect(() => {
    loadResultJobsList()
  }, [])

  const handleSave = async () => {
    const payload = resultJobsDtos.map((r) => r.resultJobsEvaluation)

    console.log('handleSave', payload)
    const result = await axiosPost(
      '/api/jobs/save_result_jobs_evaluation',
      payload
    )

    if (result.apiResult !== ApiResult.SUCCESS) {
      console.log('save_result_jobs_evaluation error', result.message)
      toast.error('저장에 실패했습니다')
      return
    }

    console.log('save_result_jobs_evaluation', result.data)
    toast.success('저장되었습니다')
  }

  return (
    <Container>
      {isPopup && (
        <ResultJobsPopup
          setIsPopup={setIsPopup}
          posterUrl={resultJobsDto?.resultJobs.posterUrl || ''}
        />
      )}
      <h2>심사위원으로서 모든 직업들을 평가해주세요.</h2>
      <Explain>
        <div>
          구체성: 직업의 내용이 얼마나 구체적으로 구성되어 있는지를 평가해주세요
        </div>
        <div>흥미: 만들어진 직업에 흥미가 생기는 정도를 평가해주세요</div>
        <div>
          사회적 필요성: 만들어진 직업이 사회에 기여하는 정도를 평가해주세요
        </div>
      </Explain>

      {resultJobsDtos.map((resultJobsDto) => (
        <ResultJobsItem
          key={resultJobsDto.resultJobs.id}
          resultJobsDto={resultJobsDto}
          resultJobsDtos={resultJobsDtos}
          setResultJobsDtos={setResultJobsDtos}
          setResultJobsDto={setResultJobsDto}
          setIsPopup={setIsPopup}
          me={me}
        />
      ))}

      <Buttons>
        <TomatoButton onClick={() => handleSave()}>저장</TomatoButton>
      </Buttons>
    </Container>
  )
}

const Container = styled.div`
  margin: 20px auto;
  width: 1000px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;

  @media (max-width: 768px) {
    padding: 10px 10px 150px 10px;
    box-sizing: border-box;
    margin: 0;
    width: 100%;
  }
`

const Buttons = styled.div`
  text-align: right;
`

const Explain = styled.div`
  font-size: 0.95rem;
  color: #666;
`

export default Evaluator
